export const CONFIGURE_APPROVAL_WORKFLOW_SETTINGS_ROUTE_PARAM_NAME = 'dealId';

export const CONFIGURE_APPROVAL_WORKFLOW_SETTINGS_ROUTE_QUERY_PARAMS = {
  originPage: 'referrer',
};
